<template>
  <div>
    <Card>
      <template slot="header">Utilization Reports</template>
      <v-layout justify-center>
        <v-menu
          :nudge-right="30"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="update()"
        >
          <v-text-field
            slot="activator"
            v-model="dateRange.startDate"
            label="Start Date"
            prepend-icon="event"
            readonly
          />
          <v-date-picker v-model="dateRange.startDate"/>
        </v-menu>
        <v-menu
          :nudge-right="30"
          transition="scale-transition"
          offset-y
          min-width="290px"
          @input="update()"
        >
          <v-text-field
            slot="activator"
            v-model="dateRange.endDate"
            label="End Date"
            prepend-icon="event"
            readonly
          />
          <v-date-picker v-model="dateRange.endDate"/>
        </v-menu>
      </v-layout>
      <v-layout
        align-center
        column
      >
        <v-flex class="pa-3">
          <v-btn
            @click="loadReport('campground')"
          >
            <v-icon left>fa-map</v-icon>Campground
          </v-btn>
          <v-btn
            @click="loadReport('campsite')"
          >
            <v-icon left>fa-map</v-icon>Campsite
          </v-btn>
          <v-btn
            @click="loadReport('parking')"
          >
            <v-icon left>fa-car</v-icon>Parking
          </v-btn>
          <v-btn
            v-if="false"
            @click="loadReport('gatePass')"
          >
            <v-icon left>fa-columns</v-icon>Gate
          </v-btn>
        </v-flex>
      </v-layout>
    </Card>
    <Campground v-if="report =='campground'"/>
    <Campsite v-if="report =='campsite'"/>
    <Parking v-if="report =='parking'"/>
    <GatePass v-if="report =='gatePass'"/>
  </div>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'
import Campground from './table/Campground'
import Campsite from './table/Campsite'
import Parking from './table/Parking'
import GatePass from './table/GatePass'

export default {
  components: {
    Campground,
    Campsite,
    Parking,
    GatePass
  },
  data () {
    return {
      report: null
    }
  },
  computed: {
    ...mapGetters({
      dateRange: 'reports/dateRange'
    })
  },
  methods: {
    ...mapActions({
      updateDateRange: 'reports/updateDateRange',
      getCampgroundReport: 'reports/getCampgroundReport',
      getCampsiteReport: 'reports/getCampsiteReport',
      getParkingReport: 'reports/getParkingReport',
      getGatePassReport: 'reports/getGatePassReport',
      getInvoiceSourceReport: 'reports/getInvoiceSourceReport'
    }),
    loadReport (report) {
      this.report = report
      let reportActions = {
        campground: () => this.getCampgroundReport(),
        campsite: () => this.getCampsiteReport(),
        parking: () => this.getParkingReport(),
        gatePass: () => this.getGatePassReport()
      }
      // run the report
      reportActions[report]()
    },
    update () {
      this.updateDateRange(this.dateRange)
      this.loadReport(this.report)
    }
  }
}
</script>
